export enum Errors {
  CREDIT_CARD_NOT_UNIQUE = 'CreditCardNotUnique',
  FORBIDDEN = 'Forbidden',
  ADDRESS_NOT_VALID = 'AddressNotValid',
  PAYMENT_ERROR = 'PaymentError',
}
